export const loanAttributes = [
  'source_id',
  'name',
  'loan_type',
  'loan_product',
  'lender',
  'origination_status',
  'sponsor',
  'borrower',
  'guarantor',
  'servicer',
  'purpose',
  'interest_type',
  'interest_rate_index',
  'interest_rate_spread',
  'interest_rate',
  'commitment_amount',
  'original_loan_amount',
  'current_loan_amount',
  'note_date',
  'first_payment_date',
  'loan_term',
  'interest_only_period',
  'interest_only_end_date',
  'amortization_term',
  'maturity_date',
  'grace_period',
  'monthly_debt_service',
  'annual_debt_service',
  'open_prepayment_date',
  'recourse',
  'recourse_description',
  'risk_rating',
  'watchlist_indicator',
  'originator',
  'underwriter',
  'relationship_manager',
  'asset_manager',
  'loan_manager',
  'ltv_origin',
  'dscr_origin',
  'debt_yield_origin',
  'ltc',
  'notes',
  'user_contact',
  'user_contact_type',
  'asset_asset_name',
  'asset_type_of_use',
  'asset_normalized_address',
  'asset_city_name',
  'asset_district_name',
  'next_payment_date',
  'measured_by',
  'currency_code',
  'currency_exchange_rates',
  'group_name',
  'payment_type',
  'ltv_current',
  'dscr_current',
  'debt_yield_current'
];

export interface LoanAttributes {
  source_id: string | null
  loan_type: string | null
  name: string | null
  loan_product: string | null
  lender: string | null
  origination_status: string | null
  sponsor: string | null
  borrower: string | null
  guarantor: string | null
  servicer: string | null
  purpose: string | null
  interest_type: string | null
  interest_rate_index: string | null
  interest_rate_spread: number | null
  interest_rate: number | null
  commitment_amount: number | null
  original_loan_amount: number | null
  current_loan_amount: number | null
  note_date: number | null
  first_payment_date: number | null
  loan_term: number | null
  interest_only_period: number | null
  interest_only_end_date: number | null
  amortization_term: number | null
  maturity_date: number | null
  grace_period: number | null
  monthly_debt_service: number | null
  annual_debt_service: number | null
  open_prepayment_date: number | null
  recourse: string | null
  recourse_description: string | null
  risk_rating: string | null
  watchlist_indicator: string | null
  originator: string | null
  underwriter: string | null
  relationship_manager: string | null
  asset_manager: string | null
  loan_manager: string | null
  ltv_origin: number | null
  dscr_origin: number | null
  debt_yield_origin: number | null
  ltc: number | null
  notes: string | null
  user_contact: string | null
  user_contact_type: string | null
  asset_asset_name: string | null
  asset_type_of_use: string | null
  asset_normalized_address: string | null
  asset_city_name: string | null
  asset_district_name: string | null
  next_payment_date: number | null
  measured_by: string | null
  currency_code: string | null
  currency_exchange_rates: { [key: string]: number } | null
  group_name: string | null
  payment_type: string | null
  ltv_current: number | null
  dscr_current: number | null
  debt_yield_current: number | null
}
